import { render, staticRenderFns } from "./loading.page.vue?vue&type=template&id=433e573b&"
import script from "./loading.page.vue?vue&type=script&lang=js&"
export * from "./loading.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports